import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  modalTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'end',
  },
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      '& .makeStyles-dialogTitle-37': {
        padding: '16px 12px !important',
      },
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  headerCell: {
    border: '2px solid white',
    backgroundColor: '#cccccc',
    color: 'black',
    fontWeight: 'bold',
    padding: '4px',
    height: '20px'
  },
  rowCell: {
    border: '2px solid white',
    backgroundColor: '#e0e0e0',
    color: 'black',
    padding: '4px',
    height: '20px'
  },
  tableContainer: {
    maxWidth: 300,
    height: 'auto',
    maxHeight: 600
  },
  dialogTitle: {
    lineHeight: '2 !important',
    padding: '8px 10px !important',
  },
  menuTogglerBtn: {
    position: 'absolute',
    bottom: '10vh',
    zIndex: 2000,
    right: '-20px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  menuTogglerMobileBtn: {
    position: 'absolute',
    bottom: '10%',
    zIndex: 200,
    right: '-15px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
  },
  menuTogglerTableBtn: {
    position: 'absolute',
    bottom: '10vh',
    zIndex: 2000,
    right: '31%',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  menuTogglerTableMobileBtn: {
    position: 'absolute',
    bottom: '10%',
    zIndex: 200,
    right: '-10px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
  },
  gridContainer: {
    paddingTop: '4px',
    borderBottom: '1px solid #ccc'
  },
  gridItem: {
    background: '#F2F2F2',
    paddingBottom: '1px',
    borderBottom: '0.5px solid #FFF',
    textAlign: 'center'
  },
  headerName: {
    flex: 0.5,
    fontWeight: 'bold',
    borderRight: '1px solid #ccc'
  }
}));
export default styles;
